import styled from 'styled-components';
import Radio from 'antd/es/radio';

export const Wrapper = styled.div`
  &&& {
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;

      .setur-segmented {
        width: 100% !important;

        .setur-segmented-item {
          min-width: 50%;
        }
      }
    }
  }
`;

export const StyledRadio = styled(Radio)`
  &&& {
    color: #fff;
    margin-right: 10px;
    margin-bottom: 16px;

    .setur-radio-checked .setur-radio-inner {
      background-color: ${({ theme }) => theme.palette.white};

      &:after {
        transform: scale(1);
        border: 4.5px solid ${({ theme }) => theme.palette.primaryBrand};
      }
    }
  }
`;
